import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";

export interface AiSummaryParams {
  report_type: "eau" | "energie" | "carbone";
  campaigns: string[];
  start_month: number;
  end_month: number;
  site_ids?: number[];
  bu_ids?: number[];
  activite_ids?: number[];
  filiere_ids?: number[];
  region_ids?: number[];
}

interface AiSummaryResponse {
  summary: string;
}

export function useGetReportAiSummary(params: AiSummaryParams, enabled = true) {
  return useQuery({
    queryKey: ["report-ai-summary", params],
    queryFn: async () => {
      const res = await fetchClient<AiSummaryResponse>("/core/reports/summary/", {
        method: "POST",
        body: params,
      });
      if (res.error) throw new Error(res.error?.detail ?? "Erreur lors de la génération");
      return res.data!;
    },
    enabled,
    staleTime: 15 * 60 * 1000,
    retry: 1,
  });
}
